import ResponsiveLayoutDesktopProvider from './hooks/useResponsiveLayoutDesktop';

import { ResponsiveLayoutDesktopProps } from './@types/ResponsiveLayoutDesktopProps';
import { selectedToggleValue } from '../../../redux/canvasResolutionSlice';
import { useSelector } from 'react-redux';

const ResponsiveLayoutDesktop = (props: ResponsiveLayoutDesktopProps) => {
	const selectedCanvasResolution = useSelector(selectedToggleValue) as any;

	return selectedCanvasResolution > 1024 ? (
		<ResponsiveLayoutDesktopProvider {...props}>{props.children}</ResponsiveLayoutDesktopProvider>
	) : null;
};

export default ResponsiveLayoutDesktop;
